// extracted by mini-css-extract-plugin
module.exports = {"root":"az_PYc","labelText":"az_QYc"};